module.exports = __webpack_public_path__ + "static/media/add-block-day-slot.4247918b.png";